"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUsedStringByTotal = void 0;
var _1 = require(".");
/**
 * Формирует строки с местом в корректных единицах измерения:
 *  - Место переводится из байт в подходящие ед измерения по заданному числу цифр
 *  - В случае разных ед измерения общего и занято мест, к занятому место приписывается его ед измерения
 * @param {number} total – занятое место пользователя (облако+почта)
 * @param {number} quota – общее место пользователя
 * @param {number} maxDigitsCount - максимальное количество цифр
 * @returns {{resultUsedString: string, convertedTotalValue: string}} - приведенное общее/занятое место
 */
var getUsedStringByTotal = function (total, quota, maxDigitsCount) {
    if (maxDigitsCount === void 0) { maxDigitsCount = 3; }
    var _a = (0, _1.toNDigits)({ bytes: total, maxDigitsCount: maxDigitsCount }), convertedUsedSpace = _a.space, convertedUsedUnits = _a.units;
    var _b = (0, _1.toNDigits)({
        bytes: quota,
        maxDigitsCount: maxDigitsCount,
    }), convertedTotalValue = _b.value, convertedTotalUnits = _b.units;
    var resultUsedString = "".concat(convertedUsedSpace).concat(convertedUsedUnits === convertedTotalUnits ? '' : " ".concat(convertedUsedUnits));
    return {
        resultUsedString: resultUsedString,
        convertedTotalValue: convertedTotalValue,
    };
};
exports.getUsedStringByTotal = getUsedStringByTotal;
//# sourceMappingURL=quota.js.map